export default "__VITE_ASSET__CWhch0Oy__"